module.exports = __webpack_public_path__ + "assets/img/c-photo_default_icon.51535ac2.png";